<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <button
        type="button"
        class="ac-close-button"
        @click="toggle(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        />
      </button>
      <div class="info-content-container">
        <span class="icon-Lock-Locked sac__font-30" />
        <div class="info-header">
          Single Sign-On
        </div>
      </div>
    </div>
    <div class="ac-body-container" style="overflow: auto">
      <p>
        Integrate your corporate Single Sign-On identity provider with
        SmartAC.com to provide a unified login for Dashboard and PRO Mobile App
        users.
      </p>
      <div class="sac__font-16 semi-bold mt-6 mb-2">
        Configure your authentication providers with these values
      </div>
      <div class="flex-row just-between align-center">
        <div class="sac__font-16">
          SP ENTITY ID
        </div>
        <div class="flex-row">
          <SACInput
            field="just"
            value="urn:amazon:cognito:sp:us-west-2_O5SQM3xdz"
            disable
            style="width: 500px"
          />
          <button
            type="button"
            @click="copyToClipboard('urn:amazon:cognito:sp:us-west-2_O5SQM3xdz')"
          >
            <i class="icon-Clipboard ml-1" />
          </button>
        </div>
      </div>
      <div class="flex-row just-between mt-2 align-center">
        <div class="sac__font-16">
          ACS URL
        </div>
        <div class="flex-row">
          <SACInput
            field="just"
            value="https://auth.smartac.com/saml2/idpresponse"
            disable
            style="width: 500px"
          />
          <button
            type="button"
            @click="copyToClipboard('https://auth.smartac.com/saml2/idpresponse')"
          >
            <i class="icon-Clipboard ml-1" />
          </button>
        </div>
      </div>
      <Transition>
        <div v-if="showInfo" class="examples margin-top-4">
          <div class="sac__font-16 semi-bold mb-2">
            Example Mapping values
          </div>
          <div class="flex-row just-between w-100">
            <div class="flex-column">
              <div class="sac__font-14">
                Google Workspace
              </div>
              <SACInput
                class="mt-2"
                field="just"
                value="email"
                disable
                style="width: 200px"
              />
              <SACInput
                class="mt-2"
                field="just"
                value="family_name"
                disable
                style="width: 200px"
              />
              <SACInput
                class="mt-2"
                field="just"
                value="given_name"
                disable
                style="width: 200px"
              />
            </div>
            <div class="flex-column ml-2">
              <div class="sac__font-14">
                Outlook (Microsoft)
              </div>
              <SACInput
                class="mt-2"
                field="just"
                value="https://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"
                disable
                style="width: 600px"
              />
              <SACInput
                class="mt-2"
                field="just"
                value="https://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname"
                disable
                style="width: 600px"
              />
              <SACInput
                class="mt-2"
                field="just"
                value="https://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"
                disable
                style="width: 600px"
              />
            </div>
          </div>
        </div>
      </Transition>
      <div class="sac__font-16 semi-bold margin-top-8 mb-2">
        Provide the SAML Attribute schema names from your SSO for mapping to
        SmartAC.com logins
        <button
          type="button"
          class="icon-Circle-Information sac__font-18"
          @click="toggleShowInfo"
        />
      </div>
      <div class="flex-row just-between">
        <div class="flex-row">
          <div class="flex-column">
            <div class="sac__font-14">
              Identity
            </div>
            <SACInput
              class="mt-2"
              field="just"
              value="Email (unique)"
              disable
              style="width: 200px"
            />
            <SACInput
              class="mt-2"
              field="just"
              value="Last Name"
              disable
              style="width: 200px"
            />
            <SACInput
              class="mt-2"
              field="just"
              value="First Name"
              disable
              style="width: 200px"
            />
          </div>
          <div class="flex-column ml-2">
            <div class="sac__font-14">
              Attribute
            </div>
            <SACInput
              class="mt-2"
              field="just"
              value="email"
              disable
              style="width: 200px"
            />
            <SACInput
              class="mt-2"
              field="just"
              value="family_name"
              disable
              style="width: 200px"
            />
            <SACInput
              class="mt-2"
              field="just"
              value="given_name"
              disable
              style="width: 200px"
            />
          </div>
        </div>
        <div class="flex-column">
          <div class="sac__font-14">
            SAML Attribute
          </div>
          <SACInput
            class="mt-2"
            :change="handleInput"
            :error="errorObj.email"
            field="email"
            value=""
            style="width: 370px"
          />
          <SACInput
            class="mt-2"
            :change="handleInput"
            :error="errorObj.family_name"
            field="family_name"
            value=""
            style="width: 370px"
          />
          <SACInput
            class="mt-2"
            :change="handleInput"
            :error="errorObj.given_name"
            field="given_name"
            value=""
            style="width: 370px"
          />
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column margin-right-4" style="width: 100%">
          <div class="sac__font-16 semi-bold margin-top-8 mb-2">
            Domain(s) authorized
          </div>
          <div class="flex-row align-center">
            <SACInput
              field="domain"
              placeholder="Corporative domain (ex. domain.com)"
              :value="domain"
              :change="handleInput"
            />
            <button
              type="button"
              class="add-button align-center flex-row"
              @click="addDomain"
            >
              Add
              <span class="icon-Plus sac__font-18 f-white ml-2" />
            </button>
          </div>
          <div v-if="errorDomain" class="sac__font-16 tomato mb-4">
            {{ errorDomain }}
          </div>
          <div class="table-list">
            <div v-for="(e, idx) in domainList" :key="idx" class="email-row align-center">
              <div class="sac__font-16 f-white">
                {{ e }}
              </div>
              <button
                type="button"
                class="icon-luc-CircleX sac__font-18 f-white ml-3"
                @click="removeDomain(idx)"
              />
            </div>
          </div>
        </div>
        <div class="flex-column margin-left-4" style="width: 100%">
          <div class="sac__font-16 semi-bold mt-6 margin-bottom-4">
            Upload the SAML configuration metadata.xml file from your SSO
          </div>
          <div>
            <form class="dropbox-form" enctype="multipart/form-data">
              <div class="dropbox-container">
                <input
                  ref="profile"
                  type="file"
                  accept=".xml"
                  aria-label="upload"
                  class="db-input"
                  @change="selectedFile"
                />
                <img
                  class="spreadsheet"
                  src="@shared/assets/img/technician/spreadsheet.png"
                  alt="Spreadsheet"
                />
                <div v-if="fileName" class="sac__font-16 text-center">
                  {{ fileName }}
                </div>
                <div v-else class="sac__font-16">
                  Add meta file
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div v-if="error" class="sac__font-16 tomato text-center margin-bottom-4">
      {{ error }}
    </div>
    <div class="ac-footer-container">
      <button
        type="button"
        class="info-form-button"
        @click="submit"
      >
        Connect
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Integrating SSO"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import SACInput from '@shared/components/sac/SACInput.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';

export default {
  name: 'IntegrationsConnectPopup',
  components: { SACInput, ProcessOverlay },
  props: {
    toggle: Function,
    iprovider: Object,
  },
  data() {
    return {
      processing: false,
      metaFile: null,
      fileName: null,
      showInfo: false,
      domainList: [...this.iprovider.domains],
      email: '',
      family_name: '',
      given_name: '',
      domain: '',
      error: '',
      errorObj: {},
      errorDomain: '',
    };
  },
  methods: {
    async submit() {
      this.error = '';
      this.errorDomain = '';
      this.errorObj = {};
      if (this.metaFile == null) {
        this.error = 'Select metadata file.';
      }
      if (this.domainList.length === 0) {
        this.errorDomain = 'Enter your domain.';
      }
      if (this.email === '') {
        this.errorObj.email = 'Enter your email mapping.';
      }
      if (this.given_name === '') {
        this.errorObj.given_name = 'Enter your given_name mapping.';
      }
      if (this.family_name === '') {
        this.errorObj.family_name = 'Enter your family_name mapping.';
      }
      if (Object.keys(this.errorObj).length > 0 || this.errorDomain !== '' || this.error !== '') {
        return;
      }
      this.processing = true;
      await this.$store.dispatch('createIdentityProvider', {
        metadataFile: this.metaFile,
        domain: this.domainList,
        email: this.email,
        family_name: this.family_name,
        given_name: this.given_name,
      });
      this.processing = false;
      this.toggle(false);
    },
    toggleShowInfo() {
      this.showInfo = !this.showInfo;
    },
    addDomain() {
      if (this.domain) {
        this.domainList = [...this.domainList, this.domain];
        this.domain = '';
      }
    },
    removeDomain(i) {
      this.domainList = [...this.domainList.filter((x, inx) => inx !== i)];
    },
    copyToClipboard(message) {
      window.navigator.clipboard.writeText(message);

      this.$store.dispatch('showSuccessToast', {
        message: `${message} copied.`,
      });
    },
    handleInput(field, value) {
      this[field] = value;
    },
    selectedFile() {
      const file = this.$refs.profile.files[0];
      this.fileName = file.name;
      const reader = new FileReader();
      reader.onload = (e) => {
        this.processing = true;
        this.metaFile = e.target.result;
        this.processing = false;
      };
      reader.readAsText(file);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-content-container {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  width: 100%;
  .info-header {
    margin-top: 5px;
    color: $BLACK;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
  }
}
.info-form-button {
  padding: 12px;
  height: 48px;
  border-radius: 6px;
  background-color: $NBLUE100;
  font-weight: 600;
  color: $WHITE;
  width: 255px;
}
.dropbox-form {
  align-items: center;
  flex: 1;
  .dropbox-sub-container {
    margin-top: 16px;
    display: flex;
    border-radius: 5px;
    text-align: left;
    font-weight: 500;
    .upload-multiple-user {
      letter-spacing: 0;
      line-height: 24px;
      min-height: 48px;
      position: relative;
    }
  }
  .dropbox-container {
    border: 3px dashed $CONTENTGRAY;
    width: 100%;
    height: 80%;
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    gap: 16px;
    padding: 48px;
    &:hover {
      opacity: 0.5;
    }
    .spreadsheet {
      width: 48px;
    }
    .db-input {
      opacity: 0;
      top: 0;
      position: absolute;
      height: 100%;
      width: 100%;
      cursor: pointer;
    }
  }
}
.info-img-header {
  margin-top: 10px;
  margin-bottom: 10px;
  color: $BLACK;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}
.review-info:before {
  content: '• ';
}
.examples {
  border: $N30 1px solid;
  padding: 5px 15px;
  border-radius: 8px;
}

.v-enter-active {
  transition: all 0.3s ease-out;
}

.v-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}

.v-enter-from,
.v-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
.add-button {
  background-color: $NBLUE90;
  padding: 10px 24px;
  margin-left: 8px;
  border-radius: 4px;
  color: $WHITE;
  font-size: 1.125rem;
  font-weight: 500;
  &.disabled {
    background-color: $N10;
    &:hover {
      opacity: 1;
    }
  }
}
.table-list {
  display: grid;
  overflow: auto;
  max-height: 300px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  .email-row {
    display: grid;
    grid-template-columns: 1fr auto;
    display: flex;
    margin: 5px;
    background-color: $PRIMARY;
    flex-direction: row;
    color: $WHITE;

    align-items: center;
    justify-content: flex-start;
    height: 45px;
    padding: 0 12px;
    border-top: 2px solid $NBLUE20;
    justify-content: space-between;
    padding: 8px 12px;
    font-size: 1rem;
    font-weight: 500;
    color: $N80;
    border-radius: 50px;
  }
}
</style>
